import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export interface BodyVisibility {
  cut: boolean;
  fill: boolean;
}

export const surfaceDifferenceBodyVisibilityAtom = atomFamily((_layerId: string) =>
  atom<BodyVisibility>({ cut: true, fill: true }),
);
